import { Loader, Image } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import NUSFinTechLabLogo from "../../images/NUS_finTech_Lab_Logo_1-removebg-preview.png";

const LoadingComponent = () => {
    const isMobile = useMediaQuery('(max-width: 1090px)');
    
    return (
        <div
            style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                zIndex: 9999, // Ensure it's above other content
            }}
            >
            <Image src={NUSFinTechLabLogo} alt={NUSFinTechLabLogo} width={isMobile ? "25vh" : "auto"} height="auto" />
            <Loader variant="dots" mt={10} />;
        </div>
    );
};

export default LoadingComponent;
